const initialState = {
    contactContent: "contact-details",
    findContactDetails: null,
	addToOtherLabel: false
};

const contactDetailsReducer = ( state = initialState, action ) => {

    switch (action.type) {
        case "CONTACT_CONTENT":
            state = {
                ...state,
                contactContent: action.payload
            };
            break;
        case "FIND_CONTACT_DETAILS":
            state = {
                ...state,
                findContactDetails: action.payload
            };
            break;
        case 'ADD_TO_OTHER_LABEL':
	        state = {
		        ...state,
		        addToOtherLabel: action.payload
	        };
	        break;
        default:
            break;
    }
    return state;
};

export default contactDetailsReducer;
